<template>
	<modal ref="modal">
		<template #title>Downgrade Membership</template>
		<template #body>
			<div class="form-floating mb-4">
				<input
					v-model="form.current_rank"
					type="text"
					id="current_membership"
					class="form-control"
					placeholder="Enter current rank"
					readonly
				/>
				<label class="form-label" for="current_membership">
					Current Membership
				</label>
			</div>
			<div class="form-floating mb-4">
				<select
					v-model="form.downgrade_rank"
					id="downgrade_to"
					class="form-select"
					placeholder="Select downgrade"
					:class="{ 'is-invalid': form.errors.downgrade_rank }"
				>
					<option v-for="rank in ranks" :key="rank" :value="rank">
						{{ rank }}
					</option>
				</select>
				<label class="form-label" for="downgrade_to">Downgrade To</label>
				<div v-if="form.errors.downgrade_rank" class="invalid-feedback">
					{{ form.errors.downgrade_rank }}
				</div>
			</div>
			<div class="form-floating mb-4">
				<textarea
					v-model="form.reason"
					id="reason"
					class="form-control"
					placeholder="Enter reason"
					style="height: 150px"
					:class="{ 'is-invalid': form.errors.reason }"
				></textarea>
				<label
					class="form-label"
					for="reason"
					:class="{ 'text-danger': form.errors.reason }"
				>
					Reason
				</label>
				<div v-if="form.errors.reason" class="invalid-feedback">
					{{ form.errors.reason }}
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="downgradeMembership"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="form.processing">Please wait...</span>
				<span v-else>Confirm Downgrade</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		member: Object,
		ranks: Object,
		user: Object,
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			admin: props.user.full_name,
			member_id: props.member.counter,
			member_email: props.member.email,
			current_rank: props.member.current_rank,
			add_alias: props.member.add_alias,
			downgrade_rank: null,
			reason: null,
		})

		const downgradeMembership = () => {
			form.post(route('admin.post.downgrade-membership'), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					toggleModal()
					form.reset()
				},
			})
		}

		return {
			form,
			modal,
			toggleModal,
			downgradeMembership,
		}
	},
}
</script>
